import * as ReactRedux from 'react-redux';
import SignupStepperComponent from './signup.stepper.component';
import { AppState } from '../app/app.types';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { passwordEncode } from '../util/auth.util';
import { createAccount } from './signup.actions';
import { AccountCreationRequest } from './signup.types';
import { checkEmailAvailability } from './signup.actions';
import { CreateUpdateRequestParameters } from '../business/business.types';
import { registerOrUpdateBusiness } from '../business/business.actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toDashboard: () => {
      return dispatch(push(paths.dashboard));
    },
    toLogin: () => {
      return dispatch(push(paths.login));
    },
    toAdminDashboard: () => {
      return dispatch(push(paths.adminDashboard));
    },
    createAccount: (request: AccountCreationRequest) => {
      return dispatch(createAccount(
        request.firstName,
        request.lastName,
        request.email,
        passwordEncode(request.email, request.password),
        request.phone
      ));
    },
    checkEmailAvailability: (email: string) => {
      return dispatch(checkEmailAvailability(email));
    },
    registerBusiness: (requestParam: CreateUpdateRequestParameters) => {
      return dispatch(registerOrUpdateBusiness(requestParam, true));
    }
  };
};

const mapStateToProps = (appState: AppState) => {
  return {
    authState: appState.authState,
    signupState: appState.signupState
  };
};

const SignupStepper: React.ComponentClass<{}> = 
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(SignupStepperComponent);

export default SignupStepper;



// WEBPACK FOOTER //
// ./src/admin/signup.stepper.tsx